"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/support/urql.ts
var urql_exports = {};
__export(urql_exports, {
  urqlFetchWithLogging: () => urqlFetchWithLogging
});
module.exports = __toCommonJS(urql_exports);
function urqlFetchWithLogging(input, init) {
  return __async(this, null, function* () {
    try {
      const res = yield fetch(input, init);
      if (res.status < 200 || res.status > 299) {
        console.warn(
          `Non-successful fetch response with url: ${res.url}, status: ${res.status}`
        );
      }
      return res;
    } catch (error) {
      console.error(
        `Failed to perform fetch with input: ${input.toString()}, error: ${error}`
      );
      throw error;
    }
  });
}
